import React, { useEffect, useState } from 'react';
import { apiRaw } from '../../api';
import './Servicios.css';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faBookOpen, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import moneda from '../moneda';
import SwiperCore from 'swiper/core';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import ServiciosLoading from '../ServiciosLoading/ServiciosLoading';
import { useLocalStorage } from '../../Context/LocalStorageContext';
import FilterByLocation from '../FilterByLocation/FilterByLocation';

export default function Servicios() {
    const [servicios, setServicios] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [subcategorias, setSubcategorias] = useState([]);
    const [tipoSeleccionado, setTipoSeleccionado] = useState(null);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
    const [loading, setLoading] = useState(true);
    const [ciudadLS] = useLocalStorage('ciudad');
    const [activeTab, setActiveTab] = useState('programas');
    const [talleres, setTalleres] = useState([]);
    const [categoriasTalleres, setCategoriasTalleres] = useState([]);
    const [tiposServicio, setTiposServicio] = useState([]);
    const [talleresVistaPor, setTalleresVistaPor] = useState('tipo');
    const [talleresPorInstitucion, setTalleresPorInstitucion] = useState([]);
    const [institucionSeleccionada, setInstitucionSeleccionada] = useState(null);

    SwiperCore.use([Navigation, Pagination, Autoplay]);

    useEffect(() => {
        cargarCategoria();
        cargarSubcategorias();
        cargarTipos();
    }, []);

    useEffect(() => {
        if (activeTab === 'programas') {
            cargarServicios();
        } else {
            cargarTalleres();
        }
    }, [ciudadLS, activeTab]);

    useEffect(() => {
        if (tiposServicio.length > 0 && !tipoSeleccionado) {
            setTipoSeleccionado(tiposServicio[0].nombre);
        }
    }, [tiposServicio]);

    const cargarTipos = () => {
        apiRaw(`/catalogos/tipo_servicio`)
            .then(r => r.json())
            .then(data => setTiposServicio(data.catalogo || []))
            .catch(error => console.error('Error al cargar tipos:', error));
    };

    const cargarServicios = () => {
        apiRaw(`/servicios`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                let lista = (data.servicios || []).filter(s => s.visible == null || Number(s.visible) !== 0);
                if (ciudadLS) {
                    lista = lista.filter(servicio => servicio.idCiudad == ciudadLS);
                }
                setServicios(lista);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar servicios:', error));
    };

    const cargarCategoria = () => {
        apiRaw(`/categorias`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const categoriasOrdenadas = (data?.categorias || [])?.sort((a, b) => a.orden - b.orden);
                setCategorias(categoriasOrdenadas);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarSubcategorias = () => {
        apiRaw(`/subcategorias`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setSubcategorias(data.subcategorias || []);
            })
            .catch(error => console.error('Error al cargar subcategorías:', error));
    };

    const cargarTalleres = () => {
        setLoading(true);
        
        // Cargar talleres desde el nuevo endpoint
        apiRaw(`/public/talleres`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then(talleres => {
                // Filtrar por ciudad si es necesario
                let talleresFiltrados = Array.isArray(talleres) ? talleres : [];
                
                if (ciudadLS) {
                    talleresFiltrados = talleresFiltrados.filter(taller => 
                        taller.idCiudad == ciudadLS
                    );
                }

                const talleresPorCeseco = {};
                const talleresPorInstMap = {};
                const categoriasMap = new Map();

                talleresFiltrados.forEach(taller => {
                    // Agrupar por CESECO
                    const cesecoId = taller.idCategoria || 'sin-ceseco';
                    if (!talleresPorCeseco[cesecoId]) {
                        talleresPorCeseco[cesecoId] = { id: cesecoId, nombre: taller.nombre_ceseco, talleres: [] };
                    }
                    talleresPorCeseco[cesecoId].talleres.push(taller);

                    // Agrupar por institución
                    const instId = taller.idInstitucion ?? 'sin-institucion';
                    if (!talleresPorInstMap[instId]) {
                        talleresPorInstMap[instId] = {
                            id: instId,
                            nombre: taller.nombre_institucion || 'Sin institución vinculada',
                            talleres: []
                        };
                    }
                    talleresPorInstMap[instId].talleres.push(taller);

                    // Categorías de población objetivo
                    if (taller.poblacionObjetivoId && !categoriasMap.has(taller.poblacionObjetivoId)) {
                        categoriasMap.set(taller.poblacionObjetivoId, true);
                    }
                });

                setTalleres(Object.values(talleresPorCeseco));
                setTalleresPorInstitucion(Object.values(talleresPorInstMap));

                const categoriasUnicas = Array.from(categoriasMap.keys()).map(id => ({
                    idCategoria: id,
                    categoria: talleresFiltrados.find(t => t.poblacionObjetivoId === id)?.categoria_nombre || `Categoría ${id}`
                }));
                setCategoriasTalleres(categoriasUnicas);
            })
            .catch(error => {
                console.error('Error al cargar talleres:', error);
                setTalleres([]);
                setTalleresPorInstitucion([]);
                setCategoriasTalleres([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // Obtener lista única de tipos de servicios
    const tiposDeServicios = [...new Set(servicios?.map(servicio => servicio.tipo))];

    // Filtrar servicios por tipo seleccionado
    const serviciosFiltrados = servicios?.filter(servicio => servicio.tipo === tipoSeleccionado);

    // Filtrar servicios por categoría seleccionada
    const serviciosFiltradosPorCategoria = categoriaSeleccionada
        ? serviciosFiltrados?.filter(servicio => servicio.idCategoria == categoriaSeleccionada)
        : serviciosFiltrados;
        
    // Filtrar talleres por categoría seleccionada
    const talleresFiltrados = categoriaSeleccionada
        ? talleres.filter(taller => taller.poblacionObjetivoId == categoriaSeleccionada)
        : talleres;

    return (
        <div id='Servicios'>
            {/* Barra de filtros unificada */}
            <div className="filters-card">
                <div className="filters-header">
                    <div className="filters-title">
                        <span className="filters-badge">Filtros</span>
                        <span className="filters-sub">Elige ciudad y tipo</span>
                    </div>
                    <div className="filters-location">
                        <FilterByLocation />
                    </div>
                </div>
                <div className="tabs-container">
                    <button 
                        className={`tab-btn ${activeTab === 'programas' ? 'active' : ''}`}
                        onClick={() => setActiveTab('programas')}
                    >
                        <FontAwesomeIcon icon={faBookOpen} className="tab-icon" />
                        Programas
                    </button>
                    <button 
                        className={`tab-btn ${activeTab === 'talleres' ? 'active' : ''}`}
                        onClick={() => setActiveTab('talleres')}
                    >
                        <FontAwesomeIcon icon={faGraduationCap} className="tab-icon" />
                        Talleres
                    </button>
                </div>
            </div>
            
            {loading ? (
                <ServiciosLoading />
            ) : (
                <div>
                    {activeTab === 'programas' ? (
                        <>
                            <div className="filtrosTipos">
                                {tiposDeServicios?.map(tipo => (
                                    <button
                                        key={tipo}
                                        className={`filtroBoton ${tipo === tipoSeleccionado ? 'activo' : ''}`}
                                        onClick={() => setTipoSeleccionado(tipo)}
                                    >
                                        {tipo}
                                    </button>
                                ))}
                            </div>
                            
                            {serviciosFiltradosPorCategoria?.length === 0 ? (
                                <div className="no-data-message">
                                    No hay programas disponibles en este momento.
                                </div>
                            ) : (
                                <div className="filtrosCategorias">
                                    <input
                                        type="button"
                                        className={`categoriaBoton ${!categoriaSeleccionada ? 'activeCategoria' : ''}`}
                                        onClick={() => setCategoriaSeleccionada(null)}
                                        value="Todo"
                                    />
                                    {categorias
                                        ?.filter(categoria => 
                                            serviciosFiltradosPorCategoria?.some(s => s.idCategoria === categoria.idCategoria)
                                        )
                                        ?.map(categoria => (
                                            <input
                                                key={categoria.idCategoria}
                                                type="button"
                                                className={`categoriaBoton ${categoriaSeleccionada === categoria.idCategoria ? 'activeCategoria' : ''}`}
                                                onClick={() => setCategoriaSeleccionada(categoria.idCategoria)}
                                                value={categoria.categoria}
                                            />
                                        ))}
                                </div>
                            )}
                            
                            {categorias
                                ?.filter(categoria => 
                                    !categoriaSeleccionada || categoria.idCategoria == categoriaSeleccionada
                                )
                                ?.map(categoria => (
                                    <div key={categoria.idCategoria} className="categoriaSection">
                                        {!categoriaSeleccionada && (
                                            <h2>
                                                {categoria.categoria} <FontAwesomeIcon icon={faAngleDoubleRight} className="iconCardh2" />
                                            </h2>
                                        )}
                                        
                                        <Swiper
                                            effect={'coverflow'}
                                            grabCursor={true}
                                            slidesPerView={'auto'}
                                            id="cardsServicio"
                                            autoplay={{ delay: 3000 }}
                                        >
                                            {serviciosFiltradosPorCategoria
                                                ?.filter(servicio => servicio.idCategoria == categoria.idCategoria)
                                                ?.map(servicio => (
                                                    <SwiperSlide key={servicio.idServicio} id="cardServicio">
                                                        <Anchor to={`/servicio/${servicio.idServicio}/${servicio.titulo.replace(/\s+/g, '-')}`}>
                                                            <div className='imgCard'>
                                                                <img src={servicio.imagen1} alt={servicio.titulo} />
                                                            </div>
                                                            <div className="cardServicioText">
                                                                <h3>{servicio.titulo}</h3>
                                                                <span>{servicio.descripcion}</span>
                                                                <div className="deFlexCard">
                                                                    <strong>
                                                                        {servicio.precio > 0 
                                                                            ? `${moneda} ${servicio.precio.toLocaleString()}`
                                                                            : 'Gratis'}
                                                                    </strong>
                                                                    <FontAwesomeIcon icon={faAngleDoubleRight} className="iconCard" />
                                                                </div>
                                                            </div>
                                                        </Anchor>
                                                    </SwiperSlide>
                                                ))}
                                        </Swiper>
                                    </div>
                                ))}
                        </>
                    ) : (
                        // Contenido de Talleres
                        <>
                            <h1>Nuestros Talleres</h1>

                            {/* Toggle secundario: Por tipo / Por institución */}
                            <div className="filtrosTipos">
                                <button
                                    className={`filtroBoton ${talleresVistaPor === 'tipo' ? 'activo' : ''}`}
                                    onClick={() => { setTalleresVistaPor('tipo'); setInstitucionSeleccionada(null); }}
                                >
                                    Por tipo
                                </button>
                                <button
                                    className={`filtroBoton ${talleresVistaPor === 'institucion' ? 'activo' : ''}`}
                                    onClick={() => { setTalleresVistaPor('institucion'); setCategoriaSeleccionada(null); }}
                                >
                                    Por institución
                                </button>
                            </div>

                            {/* Chips: cambian según la vista */}
                            {talleresVistaPor === 'tipo' ? (
                                <div className="filtrosCategorias">
                                    <input
                                        type="button"
                                        className={`categoriaBoton ${!categoriaSeleccionada ? 'activeCategoria' : ''}`}
                                        onClick={() => setCategoriaSeleccionada(null)}
                                        value="Todo"
                                    />
                                    {categoriasTalleres.map(cat => (
                                        <input
                                            key={cat.idCategoria}
                                            type="button"
                                            value={cat.categoria}
                                            className={`categoriaBoton ${categoriaSeleccionada == cat.idCategoria ? 'activeCategoria' : ''}`}
                                            onClick={() => setCategoriaSeleccionada(cat.idCategoria)}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <div className="filtrosCategorias">
                                    <input
                                        type="button"
                                        className={`categoriaBoton ${!institucionSeleccionada ? 'activeCategoria' : ''}`}
                                        onClick={() => setInstitucionSeleccionada(null)}
                                        value="Todas"
                                    />
                                    {talleresPorInstitucion
                                        .filter(inst => inst.id !== 'sin-institucion')
                                        .map(inst => (
                                            <input
                                                key={inst.id}
                                                type="button"
                                                value={inst.nombre}
                                                className={`categoriaBoton ${institucionSeleccionada == inst.id ? 'activeCategoria' : ''}`}
                                                onClick={() => setInstitucionSeleccionada(inst.id)}
                                            />
                                        ))}
                                </div>
                            )}

                            {talleres.length === 0 ? (
                                <div className="no-data-message">
                                    No hay talleres disponibles en este momento.
                                </div>
                            ) : talleresVistaPor === 'tipo' ? (
                                // Agrupado por CESECO, filtrado por tipo
                                <div className="ceseco-sections">
                                    {talleres.map(ceseco => {
                                        const items = categoriaSeleccionada
                                            ? ceseco.talleres.filter(t => t.poblacionObjetivoId == categoriaSeleccionada)
                                            : ceseco.talleres;
                                        if (items.length === 0) return null;
                                        return (
                                            <div key={`ceseco-${ceseco.id}`} className="ceseco-section">
                                                <h2>{ceseco.nombre} <FontAwesomeIcon icon={faAngleDoubleRight} className="iconCardh2" /></h2>
                                                <Swiper effect={'coverflow'} grabCursor={true} slidesPerView={'auto'} className="talleres-swiper" autoplay={{ delay: 3000 }}>
                                                    {items.map(taller => (
                                                        <SwiperSlide key={taller.idTaller} id="cardServicio">
                                                            <Anchor to={`/taller/${taller.idTaller}`}>
                                                                <div className='imgCard'><img src={taller.imagen1} alt={taller.nombre} /></div>
                                                                <div className="cardServicioText">
                                                                    <h3>{taller.nombre}</h3>
                                                                    <span>{taller.descripcion || ' '}</span>
                                                                    <div className="deFlexCard">
                                                                        <strong></strong>
                                                                        <FontAwesomeIcon icon={faAngleDoubleRight} className="iconCard" />
                                                                    </div>
                                                                </div>
                                                            </Anchor>
                                                        </SwiperSlide>
                                                    ))}
                                                </Swiper>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                // Agrupado por institución
                                <div className="ceseco-sections">
                                    {talleresPorInstitucion
                                        .filter(inst => inst.id !== 'sin-institucion')
                                        .filter(inst => !institucionSeleccionada || inst.id == institucionSeleccionada)
                                        .map(inst => {
                                            if (inst.talleres.length === 0) return null;
                                            return (
                                                <div key={`inst-${inst.id}`} className="ceseco-section">
                                                    <h2>{inst.nombre} <FontAwesomeIcon icon={faAngleDoubleRight} className="iconCardh2" /></h2>
                                                    <Swiper effect={'coverflow'} grabCursor={true} slidesPerView={'auto'} className="talleres-swiper" autoplay={{ delay: 3000 }}>
                                                        {inst.talleres.map(taller => (
                                                            <SwiperSlide key={taller.idTaller} id="cardServicio">
                                                                <Anchor to={`/taller/${taller.idTaller}`}>
                                                                    <div className='imgCard'><img src={taller.imagen1} alt={taller.nombre} /></div>
                                                                    <div className="cardServicioText">
                                                                        <h3>{taller.nombre}</h3>
                                                                        <span>{taller.descripcion || ' '}</span>
                                                                        <div className="deFlexCard">
                                                                            <strong></strong>
                                                                            <FontAwesomeIcon icon={faAngleDoubleRight} className="iconCard" />
                                                                        </div>
                                                                    </div>
                                                                </Anchor>
                                                            </SwiperSlide>
                                                        ))}
                                                    </Swiper>
                                                </div>
                                            );
                                        })}
                                </div>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};
